import React from "react";
import { useNavigate } from "react-router-dom";

export default function FundsButtonRow() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        gap: "46px",
        marginTop: "20px",
        marginBottom: "20px"
      }}
    >
   
 <button
        style={{
          background: "#FFBB57",
          color: "#181818",
          fontFamily: "Nunito, sans-serif",
          fontWeight: 700,
          fontSize: "1.08rem",
          letterSpacing: "0.18em",
          padding: "9px 48px",
          border: "2px solid #468686",
          borderRadius: "2px",
          boxShadow: "none",
          outline: "none",
          cursor: "pointer"
        }}
        onClick={() => navigate("/cashfund/create")}
      >
        CREATE FUNDS
      </button>

      <button
        style={{
          background: "#FFBB57",
          color: "#181818",
          fontFamily: "Nunito, sans-serif",
          fontWeight: 700,
          fontSize: "1.08rem",
          letterSpacing: "0.18em",
          padding: "9px 48px",
          border: "2px solid #468686",
          borderRadius: "2px",
          boxShadow: "none",
          outline: "none",
          cursor: "pointer"
        }}
        onClick={() => navigate("/dashboard/funds")}
      >
        GO TO FUNDS
      </button>
     
    </div>
  );
}
